<template>
	<div id="signup-page">
		<transition name="fade">
			<Step1 v-if="step === 1" @submit="step = 2" />
		</transition>
		<transition name="fade">
			<Step2 v-if="step === 2" @back="step = 1" @submit="step = 3" @skip="step = 3" />
		</transition>
		<transition name="fade">
			<Step3 v-if="step === 3" @back="step = 2" @submit="submitFinalStep" @skip="submitFinalStep" />
		</transition>
		<transition name="fade">
			<Step4 v-if="step === 4" />
		</transition>
	</div>
</template>

<script>
import { merge } from 'lodash';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';

export default {
	components: {
		Step1,
		Step2,
		Step3,
		Step4,
	},
	data() {
		return {
			step: 1,
		};
	},
	methods: {
		nextStep() {
			this.step++;
		},
		submitFinalStep() {
			const { user, business } = this.$store.state.signup;
			const activateUrl = `${window.location.protocol}//${window.location.hostname}/account/activate`;
			if (user.id) {
				const promises = [];
				promises.push(this.$repo.user.updatePersonalInfo(user));
				if(business) {
					promises.push(this.$repo.user.updateBusinessInfo(business));
				}
				Promise.all(promises).finally(() => {
					this.$router.push('/');
				})
			} else {
				this.$repo.user.signup(user, business, activateUrl).then((user) => {
					this.step = 4;
				});
			}
		},
	},
};
</script>

<style lang="scss">
#signup-page {
	width: 100%;
	min-height: calc(100vh - 60px);
	position: relative;

	.btn {
		padding: 15px 20px;
	}

	.signup-popup {
		width: 100%;
		color: #58595b;
		text-align: center;
		font-size: 0.875rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		.popup-wrapper {
			background-color: #fff;
			border: 1px solid #b9b9b9;
			box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
		}

		.popup-title {
			text-transform: uppercase;
			font-size: 1.75rem;
			font-weight: 400;
			margin: 0 auto 0.5em;
		}

		.popup-header {
			width: 100%;
			height: 0;
			padding-bottom: 24.71%;
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center;
		}

		.popup-content {
			padding: 30px;
		}

		input[type='text'],
		input[type='email'],
		textarea,
		select {
			width: 100%;
			padding: 10px;
			font-size: 0.75rem;
			color: #58595b;
		}

		label span {
			margin-left: 10px;
		}

		.popup-actions {
			margin: 30px auto;
			display: flex;
			justify-content: center;
			align-items: center;

			& > * + * {
				margin-left: 30px;
			}
		}

		.text-button {
			text-transform: uppercase;
			text-decoration: underline;
			color: #58595b;
		}
	}

	@media screen and (min-width: $breakpoint-tablet) {
		.signup-popup {
			width: 430px;

			&.signup-step-1 {
				width: 870px;
			}

			&.signup-step-4 {
				width: 100%;
			}
		}

		.popup-actions {
			& > * + * {
				margin-left: 90px;
			}
		}
	}
}
</style>
